import { pipe } from 'overmind';

import type { Context } from '@/overmind';

import type { SidebarState } from '.';

export const setSidebarState = pipe(
  ({ state }: Context, newSideBarState: SidebarState) => {
    if (state.sidebar.current !== newSideBarState) {
      state.sidebar.current = newSideBarState;
    }
  }
);
